/**
 * Recipient Header, found on the top of the PreviewPage, displays a recipient thumbnail (if available) and
 * a header message based on the action/flow
 */

import PropTypes from 'prop-types'

import React from 'react'
import { isEmail } from '../../../../../shared/validators'
import { connect } from 'transfer/utils/p2p-connect'
import { css } from 'glamor'
import ContactThumbnail from 'component-thumbnail'
import content from 'pp-react-l10n'
import { Text } from '@paypalcorp/pp-react'
let i18n = content('transfer/page/preview')

const STYLES = {
  header: css({
    background: '#ffffff',
    textAlign: 'center',
    marginBottom: '1rem',
    borderRadius: 5,
  }),
  thumbnailWrapper: css({
    margin: '0 auto',
  }),
}

export class RecipientHeader extends React.Component {
  static propTypes = {
    thumbnailUrl: PropTypes.string,
    firstInitial: PropTypes.string,
    lastInitial: PropTypes.string,
    showRequestLabel: PropTypes.bool,
    isCharity: PropTypes.bool,
    recipient: PropTypes.string.isRequired,
    displayName: PropTypes.string,
    shouldRenderThumbnail: PropTypes.bool,
  }

  render() {
    const recipient = this.props.displayName || this.props.recipient
    let recipientHeader = i18n('label.sendToRecipient', { recipient })

    if (this.props.showRequestLabel) {
      recipientHeader = i18n('detail.requestFromRecipient', { recipient })
    } else if (this.props.isCharity) {
      recipientHeader = i18n('label.donateToName', { displayName: recipient })
    }

    // show the email or phone below the "You're sending to Firstname Lastname"
    // if it is a contact (so there's a firstInitial) and if the recipient type
    // is email bc in the case of phone we format the phone and set it to displayName
    const shouldShowEmailOrPhone =
      this.props.firstInitial && isEmail(this.props.recipient)

    return (
      <div className={`recipientHeader ${STYLES.header}`}>
        {this.props.shouldRenderThumbnail && (
          <ContactThumbnail
            styleOverrides={{ container: { margin: '0 auto' } }}
            thumbnailUrl={this.props.thumbnailUrl}
            firstInitial={this.props.firstInitial}
            lastInitial={this.props.lastInitial}
          />
        )}
        <Text size="md" regular title={recipient}>
          {recipientHeader}
        </Text>
        {shouldShowEmailOrPhone && (
          <Text size="md" style={{ marginTop: -10 }}>
            {this.props.recipient}
          </Text>
        )}
      </div>
    )
  }
}

export default connect(({ server, recipient }) => ({
  shouldRenderThumbnail: server.env !== 'ppme' && server.env !== 'pools',
  recipient: recipient.recipient,
  displayName: recipient.displayName,
  recipientDisplayDetails: recipient.recipientDisplayDetails,
  thumbnailUrl: recipient.thumbnailUrl,
  firstInitial: recipient.firstInitial,
  lastInitial: recipient.lastInitial,
  isCharity: recipient.isCharity,
}))(RecipientHeader)
